import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-submit"
export default class extends Controller {
  static targets = ["input", "submit"]

  submitOnEnter(event) {
    if (event.shiftKey) return

    event.preventDefault()
    event.currentTarget.form.requestSubmit()
  }

  update() {
    this.submitTarget.disabled = this.inputTarget.value.trim().length === 0
  }
}
